import React from 'react';
import ReactCountryFlag from 'react-country-flag';
import { FormatMask } from './FormatMask';

// Mapa de códigos de discagem para códigos ISO de país (2 letras)
const dialCodeToCountry = {
  '1': 'US',    // USA/Canada (usando US como padrão)
  '7': 'RU',    // Russia
  '20': 'EG',   // Egypt
  '27': 'ZA',   // South Africa
  '30': 'GR',   // Greece
  '31': 'NL',   // Netherlands
  '32': 'BE',   // Belgium
  '33': 'FR',   // France
  '34': 'ES',   // Spain
  '36': 'HU',   // Hungary
  '39': 'IT',   // Italy
  '40': 'RO',   // Romania
  '41': 'CH',   // Switzerland
  '43': 'AT',   // Austria
  '44': 'GB',   // UK
  '45': 'DK',   // Denmark
  '46': 'SE',   // Sweden
  '47': 'NO',   // Norway
  '48': 'PL',   // Poland
  '49': 'DE',   // Germany
  '51': 'PE',   // Peru
  '52': 'MX',   // Mexico
  '53': 'CU',   // Cuba
  '54': 'AR',   // Argentina
  '55': 'BR',   // Brazil
  '56': 'CL',   // Chile
  '57': 'CO',   // Colombia
  '58': 'VE',   // Venezuela
  '60': 'MY',   // Malaysia
  '61': 'AU',   // Australia
  '62': 'ID',   // Indonesia
  '63': 'PH',   // Philippines
  '64': 'NZ',   // New Zealand
  '65': 'SG',   // Singapore
  '66': 'TH',   // Thailand
  '81': 'JP',   // Japan
  '82': 'KR',   // South Korea
  '84': 'VN',   // Vietnam
  '86': 'CN',   // China
  '90': 'TR',   // Turkey
  '91': 'IN',   // India
  '92': 'PK',   // Pakistan
  '93': 'AF',   // Afghanistan
  '94': 'LK',   // Sri Lanka
  '95': 'MM',   // Myanmar
  '98': 'IR',   // Iran
  '212': 'MA',  // Morocco
  '213': 'DZ',  // Algeria
  '216': 'TN',  // Tunisia
  '218': 'LY',  // Libya
  '220': 'GM',  // Gambia
  '221': 'SN',  // Senegal
  '234': 'NG',  // Nigeria
  '244': 'AO',  // Angola
  '245': 'GW',  // Guinea-Bissau
  '258': 'MZ',  // Mozambique
  '351': 'PT',  // Portugal
  '352': 'LU',  // Luxembourg
  '353': 'IE',  // Ireland
  '354': 'IS',  // Iceland
  '358': 'FI',  // Finland
  '370': 'LT',  // Lithuania
  '371': 'LV',  // Latvia
  '372': 'EE',  // Estonia
  '380': 'UA',  // Ukraine
  '381': 'RS',  // Serbia
  '385': 'HR',  // Croatia
  '386': 'SI',  // Slovenia
  '387': 'BA',  // Bosnia
  '389': 'MK',  // North Macedonia
  '420': 'CZ',  // Czech Republic
  '421': 'SK',  // Slovakia
  '502': 'GT',  // Guatemala
  '503': 'SV',  // El Salvador
  '504': 'HN',  // Honduras
  '505': 'NI',  // Nicaragua
  '506': 'CR',  // Costa Rica
  '507': 'PA',  // Panama
  '509': 'HT',  // Haiti
  '591': 'BO',  // Bolivia
  '593': 'EC',  // Ecuador
  '595': 'PY',  // Paraguay
  '598': 'UY',  // Uruguay
  '852': 'HK',  // Hong Kong
  '853': 'MO',  // Macau
  '855': 'KH',  // Cambodia
  '856': 'LA',  // Laos
  '880': 'BD',  // Bangladesh
  '886': 'TW',  // Taiwan
  '960': 'MV',  // Maldives
  '961': 'LB',  // Lebanon
  '962': 'JO',  // Jordan
  '963': 'SY',  // Syria
  '964': 'IQ',  // Iraq
  '965': 'KW',  // Kuwait
  '966': 'SA',  // Saudi Arabia
  '967': 'YE',  // Yemen
  '968': 'OM',  // Oman
  '970': 'PS',  // Palestine
  '971': 'AE',  // UAE
  '972': 'IL',  // Israel
  '973': 'BH',  // Bahrain
  '974': 'QA',  // Qatar
  '975': 'BT',  // Bhutan
  '976': 'MN',  // Mongolia
  '977': 'NP',  // Nepal
};

// Função para obter o código ISO do país baseado no código de discagem
const getCountryCode = (number) => {
  if (!number) return null;
  
  const cleanNumber = ("" + number).replace(/\D/g, "");
  
  // Tentar códigos de 3 dígitos primeiro, depois 2, depois 1
  for (let len = 3; len >= 1; len--) {
    const code = cleanNumber.substring(0, len);
    if (dialCodeToCountry[code]) {
      return dialCodeToCountry[code];
    }
  }
  
  return null;
};

// Componente React que retorna o número formatado com bandeira
const FormattedPhoneNumber = ({ serializedId }) => {
  const formatMask = new FormatMask();
  const number = serializedId?.replace('@c.us', '').replace('@s.whatsapp.net', '');
  
  if (!number) return <span>-</span>;
  
  const countryCode = getCountryCode(number);
  const formattedNumber = formatMask.setPhoneFormatMask(number);
  
  // Remover o + do início pois vamos colocar a bandeira
  const cleanFormatted = formattedNumber?.replace(/^\+/, '') || number;
  
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: '4px' }}>
      {countryCode ? (
        <ReactCountryFlag
          countryCode={countryCode}
          svg
          style={{
            width: '1.2em',
            height: '1.2em',
          }}
          title={countryCode}
        />
      ) : (
        <span>🌐</span>
      )}
      <span>{cleanFormatted}</span>
    </span>
  );
};

// Função legacy para compatibilidade (retorna string simples)
const formatSerializedId = (serializedId) => {
  const formatMask = new FormatMask();
  const number = serializedId?.replace('@c.us', '').replace('@s.whatsapp.net', '');
  
  if (!number) return '-';
  
  const formattedNumber = formatMask.setPhoneFormatMask(number);
  const cleanFormatted = formattedNumber?.replace(/^\+/, '') || number;
  
  return cleanFormatted;
};

export { FormattedPhoneNumber, getCountryCode };
export default formatSerializedId;
